<div>
  <mat-form-field>
    <mat-label>{{ 'lasku.nimi' | translate | async }}</mat-label>
    <input #asiakassearch type="text" autocomplete="kirjanpitoaineistoarkki" [matAutocomplete]="asiakasAuto" [formField]="nimi" (keydown.backspace)="tarkistaPoisto()" matInput data-lpignore="true" />

    @if (valittuAsiakas()) {
      <i style="cursor: pointer; font-size: 30px" title="Poista valinta" matSuffix class="icon ion-ios-close" (click)="poistaValittu()"></i>
    }
    <mat-hint>
      @if (naytaCheck()) {
        <mat-icon style="font-size: calc(100% + 4px); position: absolute; top: 4px; left: -4px" class="green-text">done</mat-icon>
      }
      @if (naytaCheck()) {
        <span style="display: inline-block; width: 14px"></span>
      }
      @if (asiakashaunVihjetekstiObservable | async; as asiakashaunVihjeteksti) {
        <span [class.red-warning]="asiakashaunVihjeteksti === ('lasku.muokkaa-asiakasta' | translate | async)">{{ asiakashaunVihjeteksti }}</span>
      }
    </mat-hint>
    @if (onkoVirhe(nimi, 'required') && (nimi().dirty() || nimi().touched())) {
      <mat-error>
        {{ 'lasku.validation.nimi.required' | translate | async }}
      </mat-error>
    }
    @if (onkoVirhe(nimi, 'minLength') && (nimi().dirty() || nimi().touched())) {
      <mat-error>
        {{ 'lasku.validation.nimi.minLength' | translate | async }}
      </mat-error>
    }
  </mat-form-field>
  <mat-autocomplete #asiakasAuto="matAutocomplete" [displayWith]="displayFn">
    @for (asiakas of suodatetutAsiakkaat | async; track asiakas) {
      <mat-option [value]="asiakas">
        <!-- <span class="light-blue-text">{{ asiakas.nro }}</span> -->
        {{ asiakas.nimi }}
        @if (asiakas.ytunnus != null) {
          ({{ asiakas.ytunnus }})
        }
      </mat-option>
    }
  </mat-autocomplete>

  @if (onkoYtunnusPakollinen()) {
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>{{ ytunnusPlaceholderObservable | async }}</mat-label>
      <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="ytunnus" matInput data-lpignore="true" />
      <mat-hint>{{ vatTunnuksenValidointitulos | async }}</mat-hint>
      @if (onkoVirhe(ytunnus, 'required') && (ytunnus().dirty() || ytunnus().touched())) {
        <mat-error>
          {{ 'lasku.validation.ytunnus.required' | translate | async }}
        </mat-error>
      }
      @if (onkoVirhe(ytunnus, 'invalid_ytunnus') && (ytunnus().dirty() || ytunnus().touched())) {
        <mat-error>
          {{ 'lasku.validation.ytunnus.invalid-ytunnus' | translate | async }}
        </mat-error>
      }
      @if (onkoVirhe(ytunnus, 'invalid_vat_number') && (ytunnus().dirty() || ytunnus().touched())) {
        <mat-error>
          {{ 'lasku.validation.ytunnus.invalid-vat-number' | translate | async }}
        </mat-error>
      }
      @if (onkoVirhe(ytunnus, 'invalid_vat_number_or_ytunnus') && (ytunnus().dirty() || ytunnus().touched())) {
        <mat-error>
          {{ 'lasku.validation.ytunnus.invalid-vat-number-or-ytunnus' | translate | async }}
        </mat-error>
      }
    </mat-form-field>
  }

  <mat-form-field>
    <mat-label>{{ 'lasku.katuosoite' | translate | async }}</mat-label>
    <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="katuosoite" matInput data-lpignore="true" />
    @if (onkoVirhe(katuosoite, 'required') && (katuosoite().dirty() || katuosoite().touched())) {
      <mat-error>
        {{ 'lasku.validation.katuosoite.required' | translate | async }}
      </mat-error>
    }
  </mat-form-field>

  <div>
    <mat-form-field style="width: 48%; float: left">
      <mat-label>{{ 'lasku.postinro' | translate | async }}</mat-label>
      <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="postinro" matInput data-lpignore="true" />
      @if (onkoVirhe(postinro, 'required') && (postinro().dirty() || postinro().touched())) {
        <mat-error>
          {{ 'lasku.validation.postinro.required' | translate | async }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field style="width: 48%; float: right">
      <mat-label>{{ 'lasku.postitoimipaikka' | translate | async }}</mat-label>
      <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="postitoimipaikka" matInput data-lpignore="true" />
      @if (onkoVirhe(postitoimipaikka, 'required') && (postitoimipaikka().dirty() || postitoimipaikka().touched())) {
        <mat-error>
          {{ 'lasku.validation.postitoimipaikka.required' | translate | async }}
        </mat-error>
      }
    </mat-form-field>
  </div>
  <div style="clear: both; display: block"></div>

  <mat-form-field>
    <mat-label>{{ 'lasku.maa' | translate | async }}</mat-label>
    <mat-select [formField]="maa" style="width: 100%">
      @for (maa of suodatetutMaat | async; track maa) {
        <mat-option [value]="maa.koodi">
          {{ maa.nimi }}
        </mat-option>
      }
    </mat-select>
    @if (onkoVirhe(maa, 'required') && (maa().dirty() || maa().touched())) {
      <mat-error>
        {{ 'lasku.validation.maa.required' | translate | async }}
      </mat-error>
    }
  </mat-form-field>
</div>
